/*

File handles all api calls for notifications


*/
import { browserHistory } from 'react-router'

import { server } from '../engine/server'
import { modal } from '../../core/utilities/modal'

var Notifications = Class.create({
	// #  Eventually have class update data after update
	buildingID: 0,
	levelID: 0,
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
	},
	getNotifications: function(context, limit) {
		var sortID = context.lastSortID;
		var self = this;
		var url = "notifications";

		var params = {
			limit: limit
		};

		var data = this.server.getData(url,params,true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
			context.setState({ list: response.data });
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
    },
    seen: function(notification_id) {
        var self = this;
        const url = "notifications/seen";
        const params  = {
            'notification_id': notification_id
        }

        var data = this.server.getData(url,params,false,"PUT");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	getUserSettings: function(callback) {
		var self = this;
		var url = "notifications/settings";
		var data = this.server.getData(url,null,false);

		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
	},
	updateSetting: function(id, value) {
		var self = this;
        const url = "notifications/settings/update";
        const params  = {
			'id': id,
			'value': value
        };

        var data = this.server.getData(url,params,false,"PUT");
        
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				modal.showInfo("Settings updated!", "success", "top", "center");
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	}
});

export let notifications = new Notifications();


// WEBPACK FOOTER //
// app/core/controllers/Notifications.js